import { server } from '../constants';
import { httpClient } from '../utils/HttpClient';

/*________________________
 *  Permission Group Data
 *========================
 */

/**
 * getListByCategoryLevel()
 * @param {object} props.params
 * @param {object} props.params.package { category_id, level }
 * @returns
 * Detail: get List By Category and Level, *require category_id and level
 * Method: GET
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Master/PermissionLevel
 */
export function getListByCategoryLevel(params) {
  return httpClient
    .get(`${server.PERMISSION_GROUP_URL}/getListByCategoryLevel`, {
      params,
    })
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
